import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "How does AI improve ransomware detection?",
    content: (
      <SimpleList
        points={[
          "AI-driven security analyzes behavioral patterns to detect suspicious activities before malware executes.",
          "Identifies zero-day ransomware variants without relying on traditional signature-based detection.",
        ]}
      />
    ),
  },
  {
    title: "What types of DDoS attacks can OneMind prevent?",
    content: (
      <SimpleList
        points={[
          "Volumetric Attacks – Blocks high-traffic floods that exhaust bandwidth.",
          "Application Layer Attacks – Protects against targeted layer 7 attacks on APIs and websites.",
          "Botnet-Driven Attacks – Identifies and neutralizes bot-generated traffic.",
        ]}
      />
    ),
  },
  {
    title: "How does ransomware infect networks?",
    content: (
      <SimpleList
        points={[
          "Phishing Emails – Malicious attachments and fake links trick users into installing malware.",
          "Exploiting Vulnerabilities – Attackers use unpatched software to gain entry.",
          "Credential Theft – Stolen login details allow hackers to bypass security controls.",
        ]}
      />
    ),
  },
  {
    title: "Can OneMind’s ransomware protection restore encrypted files?",
    content: (
      <SimpleList
        points={[
          "Yes! Automated rollback features restore clean file versions instantly after a ransomware attack attempt.",
        ]}
      />
    ),
  },
  {
    title: "How do businesses minimize downtime from DDoS attacks?",
    content: (
      <SimpleList
        points={[
          "Proactive traffic filtering stops malicious connections before they overwhelm networks.",
          "Load balancing ensures legitimate users can still access applications.",
          "Failover systems keep operations running in case of an attack.",
        ]}
      />
    ),
  },
  {
    title: "What industries are most vulnerable to ransomware and DDoS attacks?",
    content: (
      <SimpleList
        points={[
          "Finance & Banking – High-value targets for cyber extortion.",
          "Healthcare – Sensitive patient data makes hospitals prime ransomware targets.",
          "E-Commerce & Retail – DDoS attacks can disrupt online transactions and payment processing.",
        ]}
      />
    ),
  },
  {
    title: "Does OneMind’s DDoS protection work for cloud applications?",
    content: (
      <SimpleList
        points={[
          "Yes! Our AI-driven DDoS mitigation integrates with cloud-native security, protecting cloud workloads and SaaS applications.",
        ]}
      />
    ),
  },
  {
    title: "How does Zero Trust Security prevent ransomware infections?",
    content: (
      <SimpleList
        points={[
          "Blocks unauthorized devices from accessing corporate networks.",
          "Enforces least-privilege policies to limit user access.",
          "Implements strong authentication (MFA) to prevent stolen credentials from being used.",
        ]}
      />
    ),
  },
  {
    title: "Can OneMind’s security platform detect unknown ransomware variants?",
    content: (
      <SimpleList
        points={[
          "Yes! AI-powered behavior analysis detects ransomware strains not yet seen by traditional antivirus solutions.",
        ]}
      />
    ),
  },
  {
    title: "What compliance standards does OneMind’s security meet?",
    content: (
      <SimpleList
        points={[
          "GDPR, ., PCI-DSS, SOC 2, ISO 27001, and NIST for regulatory compliance.",
        ]}
      />
    ),
  },
  {
    title: "How does geo-blocking help prevent DDoS attacks?",
    content: (
      <SimpleList
        points={[
          "Blocks traffic from high-risk regions known for cyberattacks.",
          "Prevents access from IPs linked to botnets and malicious sources.",
        ]}
      />
    ),
  },
  {
    title: "How quickly does OneMind respond to ransomware or DDoS attacks?",
    content: (
      <SimpleList
        points={[
          "Real-time AI-driven detection mitigates attacks before damage occurs.",
          "SOC analysts respond within minutes, ensuring fast containment and resolution.",
        ]}
      />
    ),
  },
];
